import {
  ApplicationRef,
  EnvironmentInjector,
  Injectable,
  createComponent,
  inject,
  DOCUMENT,
} from '@angular/core';
import {EventManager} from '@angular/platform-browser';
import {environment} from '../../../../environments/environment';
import {DebugDlgComponent} from '../dlg/debug.dlg-component';

@Injectable({
  providedIn: 'root',
})
export class DebugDialogService {
  private readonly appRef = inject(ApplicationRef);
  private readonly envInjector = inject(EnvironmentInjector);
  private readonly document = inject(DOCUMENT);
  private readonly eventManager = inject(EventManager);
  private isOpen = false;
  private pressCount = 0;
  private pressTimer: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    if (!environment.enableDebugDialog) return;
    this.eventManager.addEventListener(
      this.document as any,
      'keydown.control.alt.shift.p',
      (e: Event) => {
        e.preventDefault();
        this.pressCount++;
        if (this.pressTimer) clearTimeout(this.pressTimer);
        if (this.pressCount >= 3) {
          this.pressCount = 0;
          this.open();
        } else {
          this.pressTimer = setTimeout(() => {
            this.pressCount = 0;
          }, 600);
        }
      },
    );
  }

  private open(): void {
    if (this.isOpen) return;
    this.isOpen = true;

    const ref = createComponent(DebugDlgComponent, {environmentInjector: this.envInjector});
    const body = this.document.body as HTMLElement;

    ref.instance.closeDialog = () => {
      this.appRef.detachView(ref.hostView);
      ref.destroy();
      body.style.overflow = '';
      this.isOpen = false;
    };

    this.appRef.attachView(ref.hostView);
    body.style.overflow = 'hidden';
    body.appendChild(ref.location.nativeElement as HTMLElement);
    ref.changeDetectorRef.detectChanges();
  }
}
